import { render, staticRenderFns } from "./picturerequirements.vue?vue&type=template&id=39ffe254&"
import script from "./picturerequirements.vue?vue&type=script&lang=js&"
export * from "./picturerequirements.vue?vue&type=script&lang=js&"
import style0 from "./picturerequirements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports